import { render, staticRenderFns } from "./Respostas.vue?vue&type=template&id=7a3362ed&scoped=true&"
import script from "./Respostas.vue?vue&type=script&lang=js&"
export * from "./Respostas.vue?vue&type=script&lang=js&"
import style0 from "./Respostas.vue?vue&type=style&index=0&id=7a3362ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3362ed",
  null
  
)

export default component.exports